import { render } from "./artificial-notification-addresses.vue?vue&type=template&id=5f328392&ts=true"
import script from "./artificial-notification-addresses.vue?vue&type=script&lang=ts"
export * from "./artificial-notification-addresses.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__